const document = `
    created
    files {
        encoding
        filename
        mimetype
        path
        signedPath
        ocrDetails
    }
    name
    ownerId
    sent
    sentDate
    ocrDetails
`;

export default document;
